import React from 'react';
import { Overlay, Wrapper, Modal } from '#app/components/ModalForm/components/styles';

export interface ModalPrimitiveProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'size'> {
  children: React.ReactNode;
  size?: string;
}

const ModalPrimitive = React.forwardRef<HTMLDivElement, ModalPrimitiveProps>(
  ({ children, ...rest }, ref) => (
    <Overlay>
      <Wrapper>
        <Modal ref={ref} {...rest}>
          {children}
        </Modal>
      </Wrapper>
    </Overlay>
  )
);

ModalPrimitive.displayName = 'Modal';

export { ModalPrimitive };
